module.exports = __webpack_public_path__ + "static/img/more-1.27cb7fba.png";